import React, { Component } from 'react'
import styled from 'styled-components'
import Snackbar from '@material-ui/core/Snackbar'
import { XMText } from './'

const Wrap = styled.div`
  & > div {
    bottom: 70px;
  }
  & > div > div {
    max-width: 275px;
    background-color: #fff;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    border-radius: 100px;
    display: flex;
    justify-content: center;
  }
  position: relative;
  z-index: 99999999999999;
`
class Toast extends Component {
  state = {}
  render() {
    const { open, message, autoHideDuration, ...props } = this.props
    return (
      <Wrap>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          open={open}
          autoHideDuration={autoHideDuration ? autoHideDuration : 3000}
          message={<XMText>{message}</XMText>}
          {...props}
        />
      </Wrap>
    )
  }
}

export default Toast



// WEBPACK FOOTER //
// ./src/components/Toast.js